export var SapSourceSortField;
(function (SapSourceSortField) {
    SapSourceSortField["SAP_SOURCE_SORT_FIELD_CREATEDAT"] = "createdAt";
    SapSourceSortField["SAP_SOURCE_SORT_FIELD_UPDATEDAT"] = "updatedAt";
    SapSourceSortField["SAP_SOURCE_SORT_FIELD_NAME"] = "name";
})(SapSourceSortField || (SapSourceSortField = {}));
